// extracted by mini-css-extract-plugin
export default {"card":"Zla79iSCoDG_zTXJote1"};